export * from './privacy-policy';
export * from './eula';
export * from './legal-modal.component';
